export const technicalForm = {
  add: {
    label: "Add a technical form",
    title: "Add a technical form",
  },
  delete: {
    label: "Delete the technical form",
    disabled:
      "This technical form cannot be deleted as it is linked to asset types.",
  },
  emptyForm: "No technical form is available",
  form: {
    name: {
      label: "Name",
    },
    usedInAssetType: {
      label: "Used by these asset types",
    },
  },
};
